"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutAccountActivation = CheckoutAccountActivation;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _reactI18next = require("react-i18next");
var _lucideReact = require("lucide-react");
var _reactPhoneNumberInput = require("react-phone-number-input");
var _reserhubAccount = require("@/actions/reserhubAccount");
var _ReserhubAccount = require("@/context/ReserhubAccount");
var _useExperimentalFeature = _interopRequireDefault(require("@/hooks/useExperimentalFeature"));
var _commerceApiClient = require("services/commerce-api/commerceApiClient");
var _useToast = require("@/hooks/use-toast");
var _errorMonitoring = _interopRequireDefault(require("@/errorMonitoring"));
var _basisTheorySelectors = require("@/selectors/basisTheorySelectors");
var _checkoutAccountActivation = require("@/metrics/user-analytics/checkoutAccountActivation");
var _AccountActivationOtpChallenge = require("./AccountActivationOtpChallenge");
var _accountActivationOtp = require("./accountActivationOtp");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var selectPurchaserValues = (0, _reduxForm.getFormValues)('purchaser');
var selectPurchaserMeta = (0, _reduxForm.getFormMeta)('purchaser');
var selectPurchaserErrors = (0, _reduxForm.getFormSyncErrors)('purchaser');
var OTP_LENGTH = 6;
var OTP_REQUEST_DEBOUNCE_MS = 800;
var RATE_LIMIT_RETRY_SECONDS = 60;
var CHECKOUT_ACTIVATION_STORAGE_PREFIX = 'checkout-account-activation';
function normalizedPhoneProfile(phoneCode, phone) {
  if (!phoneCode || !phone) return null;
  try {
    var parsedPhone = (0, _reactPhoneNumberInput.parsePhoneNumber)("+".concat(phoneCode).concat(phone.replace(/\D/g, '')));
    if (!(parsedPhone !== null && parsedPhone !== void 0 && parsedPhone.isValid())) return null;
    return {
      phoneNumber: parsedPhone.number,
      displayPhone: parsedPhone.formatInternational()
    };
  } catch (_unused) {
    return null;
  }
}
function checkoutIdentityHash(identityKey) {
  var first = 2166136261;
  var second = 5381;
  for (var index = 0; index < identityKey.length; index += 1) {
    var code = identityKey.charCodeAt(index);
    first = Math.imul(first ^ code, 16777619);
    second = Math.imul(second, 33) ^ code;
  }
  return "".concat((first >>> 0).toString(36)).concat((second >>> 0).toString(36));
}
function checkoutActivationStorageKey(identityKey) {
  return "".concat(CHECKOUT_ACTIVATION_STORAGE_PREFIX, ":").concat(checkoutIdentityHash(identityKey));
}
function reportUnexpectedOtpError(error, stage) {
  if ((0, _accountActivationOtp.accountActivationErrorTranslationKey)(error) !== 'errors.generic') return;
  _errorMonitoring["default"].notify({
    error: error instanceof Error ? error : new Error('Checkout account activation OTP failed'),
    info: {
      message: 'Checkout account activation OTP failed',
      stage: stage
    }
  });
}

/** Inline email signup/login or phone login OTP for eligible checkout guests. */
function CheckoutAccountActivation(_ref) {
  var _ref$isExchange = _ref.isExchange,
    isExchange = _ref$isExchange === void 0 ? false : _ref$isExchange;
  var _useTranslation = (0, _reactI18next.useTranslation)('payment'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var values = (0, _reactRedux.useSelector)(selectPurchaserValues) || {};
  var meta = (0, _reactRedux.useSelector)(selectPurchaserMeta) || {};
  var errors = (0, _reactRedux.useSelector)(selectPurchaserErrors) || {};
  var allowedAuthMethods = (0, _reactRedux.useSelector)(function (state) {
    var _state$whitelabelConf;
    return (_state$whitelabelConf = state.whitelabelConfig) === null || _state$whitelabelConf === void 0 || (_state$whitelabelConf = _state$whitelabelConf.env) === null || _state$whitelabelConf === void 0 || (_state$whitelabelConf = _state$whitelabelConf.reserhub) === null || _state$whitelabelConf === void 0 || (_state$whitelabelConf = _state$whitelabelConf.auth) === null || _state$whitelabelConf === void 0 ? void 0 : _state$whitelabelConf.allowedAuthMethods;
  });
  var basisTheoryAvailable = (0, _reactRedux.useSelector)(function (state) {
    return (0, _basisTheorySelectors.selectBasisTheoryInitializationConfig)(state).enabled;
  });
  var featureEnabled = (0, _useExperimentalFeature["default"])('CHECKOUT_ACCOUNT_ACTIVATION') === true;
  var _useReserhubAccount = (0, _ReserhubAccount.useReserhubAccount)(),
    accountEnabled = _useReserhubAccount.enabled,
    isUserFetched = _useReserhubAccount.isUserFetched,
    user = _useReserhubAccount.user;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    challenge = _useState2[0],
    setChallenge = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    code = _useState4[0],
    setCode = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    errorKey = _useState6[0],
    setErrorKey = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    verifying = _useState10[0],
    setVerifying = _useState10[1];
  var _useState11 = (0, _react.useState)(0),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    countdown = _useState12[0],
    setCountdown = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    completed = _useState14[0],
    setCompleted = _useState14[1];
  var _useState15 = (0, _react.useState)(''),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    dismissedIdentity = _useState16[0],
    setDismissedIdentity = _useState16[1];
  var attemptedIdentities = (0, _react.useRef)(new Set());
  var previousIdentity = (0, _react.useRef)('');
  var currentProfileRef = (0, _react.useRef)(null);
  var requestVersion = (0, _react.useRef)(0);
  var sending = (0, _react.useRef)(false);
  var verificationPending = (0, _react.useRef)(false);
  var mounted = (0, _react.useRef)(true);
  var normalizedEmail = (values.email || '').trim().toLowerCase();
  var firstName = (values.purchaserFirstName || '').trim();
  var lastName = (values.purchaserLastName || '').trim();
  var phoneProfile = (0, _react.useMemo)(function () {
    return normalizedPhoneProfile(values.phoneCode, values.phone);
  }, [values.phoneCode, values.phone]);
  var normalizedPhoneNumber = (phoneProfile === null || phoneProfile === void 0 ? void 0 : phoneProfile.phoneNumber) || '';
  var displayPhone = (phoneProfile === null || phoneProfile === void 0 ? void 0 : phoneProfile.displayPhone) || '';
  var emailMeta = meta.email || {};
  var phoneMeta = meta.phone || {};
  var emailAuthAllowed = (allowedAuthMethods === null || allowedAuthMethods === void 0 ? void 0 : allowedAuthMethods.includes('email')) === true;
  var whatsappAuthAllowed = (allowedAuthMethods === null || allowedAuthMethods === void 0 ? void 0 : allowedAuthMethods.includes('whatsapp')) === true;
  var selectedAuthMethod = emailAuthAllowed ? 'email' : whatsappAuthAllowed ? 'whatsapp' : undefined;
  var identityKey = selectedAuthMethod === 'email' ? "email\0".concat(normalizedEmail) : selectedAuthMethod && normalizedPhoneNumber ? "".concat(selectedAuthMethod, "\0").concat(normalizedPhoneNumber) : '';
  var currentProfile = selectedAuthMethod === 'email' ? {
    authMethod: 'email',
    identity: normalizedEmail,
    email: normalizedEmail,
    firstName: firstName,
    lastName: lastName
  } : selectedAuthMethod && normalizedPhoneNumber ? {
    authMethod: selectedAuthMethod,
    identity: displayPhone,
    phoneNumber: normalizedPhoneNumber
  } : null;
  currentProfileRef.current = currentProfile;
  var emailEligible = featureEnabled && emailAuthAllowed && accountEnabled && isUserFetched && !user && !isExchange && normalizedEmail && firstName && lastName && !errors.email;
  var phoneEligible = featureEnabled && !emailAuthAllowed && whatsappAuthAllowed && accountEnabled && isUserFetched && !user && !isExchange && Boolean(normalizedPhoneNumber) && !errors.phone && !errors.phoneCountry;
  var eligible = emailEligible || phoneEligible;
  var requestOtp = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(profile) {
      var requestedMode,
        requestType,
        requestIdentityKey,
        version,
        mode,
        client,
        methodId,
        resendAfterSeconds,
        expiresAt,
        response,
        _response,
        _response2,
        _response3,
        expiration,
        semanticCode,
        retryAvailableAt,
        _args = arguments,
        _t,
        _t2;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            requestedMode = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'signup';
            requestType = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'initial';
            if (!sending.current) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            requestIdentityKey = profile.authMethod === 'email' ? "email\0".concat(profile.email || '') : "".concat(profile.authMethod, "\0").concat(profile.phoneNumber || '');
            sending.current = true;
            requestVersion.current += 1;
            version = requestVersion.current;
            mode = requestedMode;
            setLoading(true);
            setErrorKey('');
            (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentStarted)({
              mode: requestedMode,
              requestType: requestType,
              authMethod: profile.authMethod
            });
            _context.prev = 2;
            client = (0, _commerceApiClient.getCommerceApiClient)();
            if (!(profile.authMethod !== 'email')) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return client.accounts.loginWithOTP({
              phoneNumber: profile.phoneNumber || '',
              deliveryMethod: profile.authMethod,
              locale: (0, _accountActivationOtp.accountActivationOtpLocale)()
            });
          case 3:
            response = _context.sent;
            mode = 'login';
            methodId = response.phoneId;
            resendAfterSeconds = response.resendAfterSeconds;
            _context.next = 11;
            break;
          case 4:
            if (!(requestedMode === 'login')) {
              _context.next = 6;
              break;
            }
            _context.next = 5;
            return client.accounts.loginWithEmailOTP({
              email: profile.email || '',
              locale: (0, _accountActivationOtp.accountActivationOtpLocale)()
            });
          case 5:
            _response = _context.sent;
            methodId = _response.emailId;
            resendAfterSeconds = _response.resendAfterSeconds;
            expiresAt = _response.expiresAt;
            _context.next = 11;
            break;
          case 6:
            _context.prev = 6;
            _context.next = 7;
            return client.accounts.registerWithEmailOTP({
              email: profile.email || '',
              firstName: profile.firstName || '',
              lastName: profile.lastName || '',
              locale: (0, _accountActivationOtp.accountActivationOtpLocale)()
            });
          case 7:
            _response2 = _context.sent;
            methodId = _response2.emailId;
            resendAfterSeconds = _response2.resendAfterSeconds;
            expiresAt = _response2.expiresAt;
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _t = _context["catch"](6);
            if (!((0, _accountActivationOtp.accountActivationSemanticCode)(_t) !== 'EMAIL_OTP_ACCOUNT_ALREADY_EXISTS')) {
              _context.next = 9;
              break;
            }
            throw _t;
          case 9:
            mode = 'login';
            _context.next = 10;
            return client.accounts.loginWithEmailOTP({
              email: profile.email || '',
              locale: (0, _accountActivationOtp.accountActivationOtpLocale)()
            });
          case 10:
            _response3 = _context.sent;
            methodId = _response3.emailId;
            resendAfterSeconds = _response3.resendAfterSeconds;
            expiresAt = _response3.expiresAt;
          case 11:
            if (!(version !== requestVersion.current)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            setChallenge(_objectSpread(_objectSpread({}, profile), {}, {
              methodId: methodId,
              mode: mode
            }));
            setCode('');
            setCountdown(resendAfterSeconds);
            if (profile.authMethod === 'email' && expiresAt) {
              expiration = Date.parse(expiresAt);
              if (Number.isFinite(expiration)) {
                (0, _accountActivationOtp.storeAccountActivation)(checkoutActivationStorageKey(requestIdentityKey), {
                  type: 'challenge',
                  methodId: methodId,
                  mode: mode,
                  expiresAt: expiration,
                  resendAvailableAt: Date.now() + resendAfterSeconds * 1000
                });
              }
            }
            (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentOtpSent)({
              mode: mode,
              requestType: requestType,
              authMethod: profile.authMethod
            });
            _context.next = 14;
            break;
          case 13:
            _context.prev = 13;
            _t2 = _context["catch"](2);
            reportUnexpectedOtpError(_t2, 'otp_request');
            if (version === requestVersion.current) {
              semanticCode = (0, _accountActivationOtp.accountActivationSemanticCode)(_t2);
              setErrorKey((0, _accountActivationOtp.accountActivationErrorTranslationKey)(_t2));
              if (semanticCode === 'OTP_RATE_LIMITED') {
                retryAvailableAt = Date.now() + RATE_LIMIT_RETRY_SECONDS * 1000;
                setCountdown(RATE_LIMIT_RETRY_SECONDS);
                (0, _accountActivationOtp.storeAccountActivation)(checkoutActivationStorageKey(requestIdentityKey), {
                  type: 'rate_limit',
                  retryAvailableAt: retryAvailableAt
                });
              } else {
                setCountdown(0);
              }
              (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentFailed)({
                mode: mode,
                authMethod: profile.authMethod,
                stage: 'otp_request',
                errorCode: semanticCode,
                requestType: requestType
              });
            }
          case 14:
            _context.prev = 14;
            sending.current = false;
            if (mounted.current) setLoading(false);
            return _context.finish(14);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 13, 14, 15], [6, 8]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var verifyOtp = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(otp) {
      var version, activeElement, failureStage, client, refreshedUser, challengeIdentityKey, nextErrorKey, _t3;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!challenge || otp.length !== OTP_LENGTH || verificationPending.current)) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return");
          case 1:
            verificationPending.current = true;
            requestVersion.current += 1;
            version = requestVersion.current;
            activeElement = document.activeElement;
            if (activeElement instanceof HTMLInputElement && activeElement.dataset.inputOtp !== undefined) {
              activeElement.blur();
            }
            setVerifying(true);
            setErrorKey('');
            (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentOtpSubmitted)({
              mode: challenge.mode,
              authMethod: challenge.authMethod
            });
            failureStage = 'otp_validation';
            _context2.prev = 2;
            client = (0, _commerceApiClient.getCommerceApiClient)();
            _context2.next = 3;
            return client.accounts.validateOTPCode('POST', JSON.stringify({
              code: otp,
              methodId: challenge.methodId
            }), {
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 3:
            failureStage = 'session_refresh';
            _context2.next = 4;
            return dispatch((0, _reserhubAccount.fetchReserhubUser)());
          case 4:
            refreshedUser = _context2.sent;
            if (refreshedUser !== null && refreshedUser !== void 0 && refreshedUser.id) {
              _context2.next = 5;
              break;
            }
            throw new Error('Unified account refresh failed');
          case 5:
            (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentSucceeded)({
              mode: challenge.mode,
              authMethod: challenge.authMethod
            });
            (0, _useToast.toast)({
              variant: 'success',
              title: t(challenge.mode === 'login' ? 'checkout_account_activation.login_success_title' : 'checkout_account_activation.success_title'),
              description: t(challenge.mode === 'login' ? 'checkout_account_activation.login_success_description' : 'checkout_account_activation.success_description')
            });
            challengeIdentityKey = challenge.authMethod === 'email' ? "email\0".concat(challenge.email || '') : "".concat(challenge.authMethod, "\0").concat(challenge.phoneNumber || '');
            (0, _accountActivationOtp.removeStoredAccountActivation)(checkoutActivationStorageKey(challengeIdentityKey));
            if (version === requestVersion.current) {
              setCompleted(true);
            }
            _context2.next = 7;
            break;
          case 6:
            _context2.prev = 6;
            _t3 = _context2["catch"](2);
            reportUnexpectedOtpError(_t3, failureStage);
            if (version === requestVersion.current) {
              setCode('');
              nextErrorKey = (0, _accountActivationOtp.accountActivationErrorTranslationKey)(_t3);
              setErrorKey(nextErrorKey);
              if (nextErrorKey === 'errors.invalid_code') setCountdown(0);
              (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentFailed)({
                mode: challenge.mode,
                authMethod: challenge.authMethod,
                stage: failureStage,
                errorCode: (0, _accountActivationOtp.accountActivationSemanticCode)(_t3)
              });
            }
          case 7:
            _context2.prev = 7;
            verificationPending.current = false;
            if (version === requestVersion.current) {
              setVerifying(false);
            }
            return _context2.finish(7);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 6, 7, 8]]);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [challenge, dispatch, t]);
  (0, _react.useEffect)(function () {
    if (previousIdentity.current !== identityKey) {
      requestVersion.current += 1;
      verificationPending.current = false;
      setChallenge(null);
      setCode('');
      setErrorKey('');
      setVerifying(false);
      setCountdown(0);
      setDismissedIdentity('');
      var stored = (0, _accountActivationOtp.readStoredAccountActivation)(checkoutActivationStorageKey(identityKey));
      var profile = currentProfileRef.current;
      if ((stored === null || stored === void 0 ? void 0 : stored.type) === 'challenge' && (profile === null || profile === void 0 ? void 0 : profile.authMethod) === 'email') {
        attemptedIdentities.current.add(identityKey);
        setChallenge(_objectSpread(_objectSpread({}, profile), {}, {
          methodId: stored.methodId,
          mode: stored.mode
        }));
        setCountdown(Math.max(0, Math.ceil((stored.resendAvailableAt - Date.now()) / 1000)));
      } else if ((stored === null || stored === void 0 ? void 0 : stored.type) === 'rate_limit') {
        attemptedIdentities.current.add(identityKey);
        setErrorKey('errors.rate_limited');
        setCountdown(Math.max(1, Math.ceil((stored.retryAvailableAt - Date.now()) / 1000)));
      } else if ((stored === null || stored === void 0 ? void 0 : stored.type) === 'dismissed') {
        attemptedIdentities.current.add(identityKey);
        setDismissedIdentity(identityKey);
      }
    }
    previousIdentity.current = identityKey;
  }, [identityKey]);
  (0, _react.useEffect)(function () {
    if (!eligible || loading || challenge || countdown > 0 || completed || dismissedIdentity === identityKey) {
      return undefined;
    }
    if (attemptedIdentities.current.has(identityKey)) return undefined;
    function startRequest() {
      if (sending.current) return;
      attemptedIdentities.current.add(identityKey);
      if (selectedAuthMethod === 'email') {
        requestOtp({
          authMethod: 'email',
          identity: normalizedEmail,
          email: normalizedEmail,
          firstName: firstName,
          lastName: lastName
        }, 'signup');
      } else if (selectedAuthMethod && normalizedPhoneNumber) {
        requestOtp({
          authMethod: selectedAuthMethod,
          identity: displayPhone,
          phoneNumber: normalizedPhoneNumber
        }, 'login');
      }
    }
    var identityActive = selectedAuthMethod === 'email' ? emailMeta.active : phoneMeta.active;
    if (!identityActive) {
      startRequest();
      return undefined;
    }
    var timer = window.setTimeout(startRequest, OTP_REQUEST_DEBOUNCE_MS);
    return function () {
      return window.clearTimeout(timer);
    };
  }, [challenge, countdown, dismissedIdentity, emailMeta.active, eligible, firstName, lastName, loading, normalizedEmail, displayPhone, normalizedPhoneNumber, phoneMeta.active, identityKey, requestOtp, selectedAuthMethod, completed]);
  (0, _react.useEffect)(function () {
    if (countdown <= 0) return undefined;
    var timer = window.setTimeout(function () {
      return setCountdown(function (seconds) {
        return seconds - 1;
      });
    }, 1000);
    return function () {
      return window.clearTimeout(timer);
    };
  }, [countdown]);
  (0, _react.useEffect)(function () {
    return function () {
      mounted.current = false;
      requestVersion.current += 1;
    };
  }, []);
  function close() {
    var authMethod = (challenge === null || challenge === void 0 ? void 0 : challenge.authMethod) || selectedAuthMethod;
    if (authMethod) {
      (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentDismissed)({
        mode: (challenge === null || challenge === void 0 ? void 0 : challenge.mode) || 'pending',
        authMethod: authMethod
      });
    }
    requestVersion.current += 1;
    verificationPending.current = false;
    (0, _accountActivationOtp.storeAccountActivation)(checkoutActivationStorageKey(identityKey), {
      type: 'dismissed'
    });
    setDismissedIdentity(identityKey);
    setChallenge(null);
    setCode('');
    setErrorKey('');
    setLoading(false);
    setVerifying(false);
    setCountdown(0);
  }
  function handleCodeChange(value) {
    var digits = value.replace(/\D/g, '').slice(0, OTP_LENGTH);
    setCode(digits);
    if (errorKey) setErrorKey('');
    if (digits.length === OTP_LENGTH) verifyOtp(digits);
  }
  if (!featureEnabled || !selectedAuthMethod || !accountEnabled || !isUserFetched || isExchange || user || completed) {
    return null;
  }
  if (dismissedIdentity === identityKey) return null;
  // Account detection is intentionally silent; only the resolved challenge or an error is shown.
  if (!challenge && !errorKey) return null;
  if (challenge) {
    return /*#__PURE__*/_react["default"].createElement(_AccountActivationOtpChallenge.AccountActivationOtpChallenge, {
      title: challenge.mode === 'signup' ? /*#__PURE__*/_react["default"].createElement("strong", {
        className: "font-semibold text-gray-800"
      }, t('checkout_account_activation.signup_title')) : /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
        t: t,
        i18nKey: challenge.authMethod === 'email' ? 'checkout_account_activation.login_title' : 'checkout_account_activation.phone_login_title',
        components: {
          emphasis: /*#__PURE__*/_react["default"].createElement("strong", {
            className: "font-semibold text-gray-800"
          })
        }
      }),
      description: challenge.authMethod !== 'email' ? t('checkout_account_activation.phone_login_description', {
        phone: challenge.identity
      }) : /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
        t: t,
        i18nKey: challenge.mode === 'login' ? 'checkout_account_activation.login_description' : basisTheoryAvailable ? 'checkout_account_activation.signup_description' : 'checkout_account_activation.signup_description_without_saved_cards',
        values: {
          email: challenge.email
        },
        components: {
          email: /*#__PURE__*/_react["default"].createElement("strong", {
            className: "font-semibold text-gray-800"
          })
        }
      }),
      helpText: t(challenge.authMethod === 'whatsapp' ? 'checkout_account_activation.phone_login_code_help_whatsapp' : challenge.mode === 'login' ? 'checkout_account_activation.login_code_help' : 'checkout_account_activation.signup_code_help'),
      code: code,
      errorMessage: errorKey ? t("checkout_account_activation.".concat(errorKey)) : undefined,
      invalid: errorKey === 'errors.invalid_code',
      loading: loading,
      verifying: verifying,
      countdown: countdown,
      onCodeChange: handleCodeChange,
      onClose: close,
      onResend: function onResend() {
        return requestOtp(challenge, challenge.mode, 'resend');
      },
      testId: "checkout-account-activation"
    });
  }
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "relative mb-6 mt-0 rounded-3xl bg-gray-50 px-5 py-7 text-center shadow-md sm:my-6 sm:px-10",
    "data-testid": "checkout-account-activation",
    "data-sentry-component": "CheckoutAccountActivation",
    "data-sentry-source-file": "CheckoutAccountActivation.tsx"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "absolute right-4 top-4 rounded p-1 text-gray-500 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary-regular",
    "aria-label": t('checkout_account_activation.close'),
    onClick: close
  }, /*#__PURE__*/_react["default"].createElement(_lucideReact.X, {
    "aria-hidden": "true",
    className: "h-5 w-5",
    "data-sentry-element": "X",
    "data-sentry-source-file": "CheckoutAccountActivation.tsx"
  })), errorKey && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-4",
    role: "alert"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm text-error-strong"
  }, t("checkout_account_activation.".concat(errorKey))), countdown > 0 ? /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-2 text-sm text-gray-500"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    t: t,
    i18nKey: "checkout_account_activation.resend_in",
    values: {
      time: "".concat(String(Math.floor(countdown / 60)).padStart(2, '0'), ":").concat(String(countdown % 60).padStart(2, '0'))
    },
    components: {
      time: /*#__PURE__*/_react["default"].createElement("strong", {
        className: "font-semibold text-gray-700"
      })
    }
  })) : null, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "mt-3 rounded-md bg-primary-regular px-4 py-2 text-sm font-semibold text-white disabled:opacity-50",
    disabled: loading || countdown > 0 || !currentProfile,
    onClick: function onClick() {
      if (currentProfile) {
        requestOtp(currentProfile, currentProfile.authMethod === 'email' ? 'signup' : 'login', 'retry');
      }
    }
  }, t('checkout_account_activation.retry'))));
}